import { gql } from '@apollo/client/core';

import { ORDER_FIELDS } from '@/entities/order';

import { ORDER_FISCAL_REFUND_EXECUTION_FIELDS } from './order-fiscalization.fragments.graphql';

export const GET_ORDER_FISCAL_REFUND_OPERATION = gql`
  ${ORDER_FISCAL_REFUND_EXECUTION_FIELDS}

  query GetOrderFiscalRefundOperation($orderId: ID!) {
    orderFiscalRefundOperation(orderId: $orderId) {
      ...OrderFiscalRefundExecutionFields
    }
  }
`;

export const PREPARE_ORDER_FISCAL_REFUND = gql`
  ${ORDER_FISCAL_REFUND_EXECUTION_FIELDS}

  mutation PrepareOrderFiscalRefund($input: PrepareOrderFiscalRefundInput!) {
    prepareOrderFiscalRefund(input: $input) {
      ...OrderFiscalRefundExecutionFields
    }
  }
`;

export const START_ORDER_FISCAL_REFUND = gql`
  ${ORDER_FISCAL_REFUND_EXECUTION_FIELDS}

  mutation StartOrderFiscalRefund($input: OrderFiscalOperationIdentityInput!) {
    startOrderFiscalRefund(input: $input) {
      ...OrderFiscalRefundExecutionFields
    }
  }
`;

export const COMPLETE_ORDER_FISCAL_REFUND = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_REFUND_EXECUTION_FIELDS}

  mutation CompleteOrderFiscalRefund($input: CompleteOrderFiscalRefundInput!) {
    completeOrderFiscalRefund(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalRefundExecutionFields
      }
    }
  }
`;

/**
 * Повтор, чтение ФН и ответ «Чек вышел?» для возврата: мутации общие с оплатой,
 * но план чека возврата другой, поэтому берутся только операция и следующий шаг,
 * а исполнение перечитывается через `orderFiscalRefundOperation`.
 */
export const RETRY_ORDER_FISCAL_REFUND_RECEIPT = gql`
  mutation RetryOrderFiscalRefundReceipt($input: RetryOrderFiscalReceiptInput!) {
    retryOrderFiscalReceipt(input: $input) {
      next_action
      operation {
        id
        status
      }
    }
  }
`;

export const RESOLVE_ORDER_FISCAL_REFUND_RECEIPT = gql`
  mutation ResolveOrderFiscalRefundReceipt($input: ResolveOrderFiscalReceiptInput!) {
    resolveOrderFiscalReceipt(input: $input) {
      execution {
        next_action
        operation {
          id
          status
        }
      }
    }
  }
`;

export const ANSWER_ORDER_FISCAL_REFUND_RECEIPT_PRINTED = gql`
  mutation AnswerOrderFiscalRefundReceiptPrinted($input: AnswerOrderFiscalReceiptPrintedInput!) {
    answerOrderFiscalReceiptPrinted(input: $input) {
      execution {
        next_action
        operation {
          id
          status
        }
      }
    }
  }
`;

export const FAIL_ORDER_FISCAL_REFUND = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_REFUND_EXECUTION_FIELDS}

  mutation FailOrderFiscalRefund($input: FailOrderFiscalRefundInput!) {
    failOrderFiscalRefund(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalRefundExecutionFields
      }
    }
  }
`;
